export const CheckIcon = ({ ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <rect width="20" height="20" rx="10" fill="#3FC486" />
    <path
      d="M8.80958 11.8868L14.281 6.41602L15.1227 7.25768L8.80958 13.5708L5.02148 9.78268L5.86315 8.94101L8.80958 11.8868Z"
      fill="white"
    />
  </svg>
);
